@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/components/custom-scroll/custom-scroll' as *;

.chatInputFieldWrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  @include border-radius-r2;
  padding: 0;
  border: 1px solid var(--border-soft);

  &:focus-within {
    border: 1px solid var(--border-primary);
  }

  background-color: var(--surface-default);
  box-shadow: var(--elevation-moderate);
}

.chatInputFieldWrapperPending {
  composes: chatInputFieldWrapper;

  &:focus-within {
    border: 1px solid var(--border-soft);
  }
}

.textAreaWrapper {
  display: flex;
  align-items: center;
  overflow: hidden;
  position: relative;
  gap: 8px;
  background-color: transparent;
  border: none;
  padding: 12px;
  width: 100%;

  &:hover {
    border-color: var(--border-soft);
  }
}

.enterIcon {
  display: flex;
  position: absolute;
  border: 1px solid var(--icon-disabled);
  padding: 4px 8px;
  width: 67px;
  height: 24px;
  @include typography-v2-ui-xs;
  color: var(--icon-disabled);
  align-items: center;
  @include border-radius-r1;

  svg {
    align-items: center;
    margin-left: 4px;

    path {
      fill: var(--icon-disabled);
    }
  }
}

.textareaElement {
  flex: 1;
  border: none;
  background-color: transparent;
  caret-color: var(--text-primary);
  -moz-appearance: textfield;
  color: var(--text-default);

  &:active,
  &:hover,
  &:focus-within {
    border-color: transparent;
    outline: none;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  @include custom-scroll-minimal;
  @include typography-v2-body-base;
  display: inline-block;
  width: fit-content;
  padding: 0;
  resize: none;
  margin-right: 60px;

  &::placeholder {
    color: var(--text-disabled);
  }

  max-height: 240px;

  &::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-thumb:hover {
    background-color: var(--surface-neutral);
  }
}

.chatInputFieldContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.uploadingSection {
  padding: 12px;
  width: 100%;
}

.uploadingSectionNoPadding {
  composes: uploadingSection;
  padding: 0;
}
